import styled from '@emotion/styled';
import { Button } from 'antd';
import { useGetRegionLabel } from 'hooks/business/useRegion';

export interface RegionSelectProps {
  regions: General.UpperCaseRegion[];
  activeRegion: General.UpperCaseRegion;
  onActiveRegionChange: (region: General.UpperCaseRegion) => void;
}

function RegionSelect(props: RegionSelectProps) {
  const { regions, activeRegion, onActiveRegionChange } = props;

  const getRegionLabel = useGetRegionLabel();

  return (
    <Container>
      {regions.map((region) => {
        const isActive = region === activeRegion;

        return (
          <Button
            key={region}
            type={isActive ? 'primary' : undefined}
            ghost={isActive}
            size="small"
            shape="round"
            onClick={() => onActiveRegionChange(region)}
          >
            {getRegionLabel(region)}
          </Button>
        );
      })}
    </Container>
  );
}

const Container = styled.div`
  > button {
    margin-right: 12px;
    margin-bottom: 16px;
  }
`;

export default RegionSelect;
